import { DEFAULT_REFERENCE_TABLE_FIELDS_OPTIONS } from "../../constants/default-values";

const state = {};
const mutations = {};
const actions = {};
const getters = {
    referenceTableFields(state, getters, rootState) {
        // Check admin level setting
        const adminSetting = rootState.general.adminSetting;
        if (adminSetting && adminSetting.setting && adminSetting.setting.use_admin_level__advance_setting_reference_table_fields) {
            const adminLevelSetting = adminSetting.setting.admin_level__advance_setting_reference_table_fields;
            if (adminLevelSetting && adminLevelSetting.length) {
                return adminLevelSetting;
            }
        }
        const agency = rootState.authentication.agency;
        if (agency && agency.advance_setting) {
            const listFields = agency.advance_setting.reference_table_fields;
            if (listFields && listFields.length) {
                return listFields;
            }
        }
        return DEFAULT_REFERENCE_TABLE_FIELDS_OPTIONS;
    },
};

export default {
    state,
    mutations,
    actions,
    getters
};




// WEBPACK FOOTER //
// ./src/store/modules/reference.js